import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import ContractAssociationGDC from './ContractAssociation.GDC';
import ContractAssociationGDG from './ContractAssociation.GDG';
import ContractAssociationEFG from './ContractAssociation.EFG';

export const WrongContractDataModals = {
  SelectOptions: 'selectOptions',
  Confirm: 'confirm'
};

const ContractAssociation = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <ContractAssociationGDC {...props} />;
    case Portal.Gasguajira:
      return <ContractAssociationGDG {...props} />;
    case Portal.Efigas:
      return <ContractAssociationEFG {...props} />;
    default:
      return <></>;
  }
};

export default ContractAssociation;
